<template>
  <div>
    <el-form ref="formRef"  label-width="88px">
      <el-form-item label="用户评论：">
        <p>{{msg}}</p>
      </el-form-item>
      <el-form-item label="官方回复：">
        <el-input :rows="4" type="textarea" v-model="preMsg" placeholder="请输入内容" style="width:33em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { officialReply } from "@/api/url";

export default {
  name: "MsgReplyDialog",
  props: {
    value: Object
  },
  data() {
    return {
      msg: this.value.row.msg,
      zoneId: this.value.row.zoneId,
      userId: this.value.row.userId,
      id: this.value.row.id,
      preMsg: this.value.row.officialReplyMsg?this.value.row.officialReplyMsg:"",
      loading: false,
      // msg:'',
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.preMsg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '回复不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.id;
      param['zoneId'] = this.zoneId;
      param['toUserId'] = this.userId;
      param['msg'] = this.preMsg;
      postFormData(officialReply, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
